module.exports = __webpack_public_path__ + "static/img/102_TO8_1784_og.789c75e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/102_TO8_1784_og.jpg
// module id = b/5e
// module chunks = 0